<template>
<div>

  <div class="title">
    <div class="iconfont iconfanhui" @click="$router.go(-1)"></div>
    <div class="text">库存</div>
    <div class="iconfont iconkucun"></div>
  </div>
  <div class="body">
    <div class="item">
      <div class="head">
        <div class="left">
          <div class="first">戒指</div>
          <div class="second">库存20件</div>
        </div>
        <div class="right">
          <div class="first">更多</div>
          <div>图标</div>
        </div>
      </div>
      <div class="item_li">
        <ul>
          <li>
            <div class="img">
              <div class="photo">图片</div>
              <div class="btn">上架</div>
            </div>
            <div class="txt">文字</div>
          </li>
          <li>
            <div class="img">
              <div class="photo">图片</div>
              <div class="btn">上架</div>
            </div>
            <div class="txt">文字</div>
          </li>
          <li>
            <div class="img">
              <div class="photo">图片</div>
              <div class="btn">上架</div>
            </div>
            <div class="txt">文字</div>
          </li>
          <li>
            <div class="img">
              <div class="photo">图片</div>
              <div class="btn">上架</div>
            </div>
            <div class="txt">文字</div>
          </li>
          <li>
            <div class="img">
              <div class="photo">图片</div>
              <div class="btn">上架</div>
            </div>
            <div class="txt">文字</div>
          </li>
          <li>
            <div class="img">
              <div class="photo">图片</div>
              <div class="btn">上架</div>
            </div>
            <div class="txt">文字</div>
          </li>
          <li>
            <div class="img">
              <div class="photo">图片</div>
              <div class="btn">上架</div>
            </div>
            <div class="txt">文字</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="item">
      <div class="head">
        <div class="left">
          <div class="first">戒指</div>
          <div class="second">库存20件</div>
        </div>
        <div class="right">
          <div class="first">更多</div>
          <div>图标</div>
        </div>
      </div>
      <div class="item_li">
        <ul>
          <li>
            <div class="img">
              <div class="photo">图片</div>
              <div class="btn">上架</div>
            </div>
            <div class="txt">文字</div>
          </li>
          <li>
            <div class="img">
              <div class="photo">图片</div>
              <div class="btn">上架</div>
            </div>
            <div class="txt">文字</div>
          </li>
          <li>
            <div class="img">
              <div class="photo">图片</div>
              <div class="btn">上架</div>
            </div>
            <div class="txt">文字</div>
          </li>
          <li>
            <div class="img">
              <div class="photo">图片</div>
              <div class="btn">上架</div>
            </div>
            <div class="txt">文字</div>
          </li>
          <li>
            <div class="img">
              <div class="photo">图片</div>
              <div class="btn">上架</div>
            </div>
            <div class="txt">文字</div>
          </li>
          <li>
            <div class="img">
              <div class="photo">图片</div>
              <div class="btn">上架</div>
            </div>
            <div class="txt">文字</div>
          </li>
          <li>
            <div class="img">
              <div class="photo">图片</div>
              <div class="btn">上架</div>
            </div>
            <div class="txt">文字</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
</template>
<script>
export default {
  data(){
    return{

    }
  },
  methods: {
    goback:function(){
      console.log(111)
    }
  }
}
</script>
<style lang="scss" scoped>
  .title{
    display: flex;
    justify-content: space-between;
    line-height: 44px;
    padding: 0 14px;
    height: 44px;
    background: #fff;
    .iconfont{
      font-size: 25px;
    }
    .text{
      font-size: 15px;
    }
  }
  .body{
    margin-top: 3px;
    padding: 0 20px;
    background: #fff;
    .item{
      .head{
        display: flex;
        height: 14px;
        justify-content: space-between;
        font-size: 14px;
        padding: 20px 0;
        // line-height: 53px;
        .left{
          display: flex;
          line-height: 14px;
          .first{
            padding-right: 15px;
            border-right: 1px solid #000;
          }
          .second{
            padding-left: 10px;
          }
        }
        .right{
          display: flex;
          .first{
            padding-right: 20px;
          }
        }
      }
    }
    .item_li{
      ul{
        display: flex;
        list-style: none;
        li{
          text-align: center;
          font-size: 14px;
          margin-right: 7px;
          .img{
            position: relative;
            width:134px;
            height:121px;
            background:rgba(237,237,237,1);
            border-radius:4px;
            .btn{
              position: absolute;
              bottom: 9px;
              left: 50%;
              transform: translateX(-50%);
              width:97px;
              height:32px;
              background:rgba(62,33,14,1);
              border-radius:4px;
              line-height: 32px;
              color: #fff;
              font-family:PingFangSC-Light;
              font-weight:300;
            }
          }
          .txt{
            padding-top: 15px;
          }
        }
      }
    }
  }
</style>
<style>
  body{
    background:rgba(237,237,237,1);
  }
</style>


